/**
 * Resolve profile photo URL from stored path (relative or absolute).
 */
export function getProfilePhotoUrl(photoPath?: string | null): string | null {
  if (!photoPath) return null;
  if (photoPath.startsWith('http://') || photoPath.startsWith('https://')) return photoPath;
  const apiUrl = import.meta.env.VITE_API_URL || '';
  const uploadsBase = apiUrl.replace(/\/api\/?$/, '');
  return uploadsBase ? `${uploadsBase}/uploads/${photoPath}` : `/uploads/${photoPath}`;
}
